module.exports = __webpack_public_path__ + "static/media/calendar_icon.14088419.png";